import {
  REPORTS,
  REPORT_MANAGER,
  REPORT_ACCOUNTS_LEDGER,
  REPORT_BALANCE_SHEET,
  REPORT_CASH_BANK_BOOK,
  REPORT_INCOME_STATEMENT,
  REPORT_TRIAL_BALANCE,
  REPORT_VOUCHER_TXN,
} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {guard} from './route-guard'

export const ReportsRouting: IAppRoutes = {
  link: REPORTS,
  childrens: [
    {
      link: REPORT_MANAGER,
      element: guard(() => import('@modules/reports/BuiltinRpt'), [REPORT_MANAGER]),
    },
    // The six sampled reports, each behind its own feature (@modules/reports/reportPages.ts)
    {
      link: REPORT_TRIAL_BALANCE,
      element: guard(() => import('@modules/reports/ReportPage'), [REPORT_TRIAL_BALANCE]),
    },
    {
      link: REPORT_BALANCE_SHEET,
      element: guard(() => import('@modules/reports/ReportPage'), [REPORT_BALANCE_SHEET]),
    },
    {
      link: REPORT_INCOME_STATEMENT,
      element: guard(() => import('@modules/reports/ReportPage'), [REPORT_INCOME_STATEMENT]),
    },
    {
      link: REPORT_ACCOUNTS_LEDGER,
      element: guard(() => import('@modules/reports/ReportPage'), [REPORT_ACCOUNTS_LEDGER]),
    },
    {
      link: REPORT_CASH_BANK_BOOK,
      element: guard(() => import('@modules/reports/ReportPage'), [REPORT_CASH_BANK_BOOK]),
    },
    {
      link: REPORT_VOUCHER_TXN,
      element: guard(() => import('@modules/reports/ReportPage'), [REPORT_VOUCHER_TXN]),
    },
  ],
}
